import React, { FC } from 'react';
import GlobalStyleTag from '@narvar/nth-bit-global-style-tag';
import DeliveryManagement from './DeliveryManagement';

const App: FC = () => (
  <>
    <GlobalStyleTag />
    <DeliveryManagement />
  </>
);

export default App;
